import request from './request'

interface SignedUploadResponse {
  uploadUrl: string
  publicUrl: string
}

class Uploader {
  private buildApiUrl(path: string) {
    const base = process.env.VUE_APP_API_URL
    if (base && base.length > 0) {
      return `${base}${path}`
    }
    return path
  }

  private async uploadViaSignedUrl(body: BodyInit, fileName: string, contentType: string) {
    try {
      console.log('Requesting signed URL with:', { fileName, contentType })
      const endpoint = this.buildApiUrl('/otafiles/storage/signed-upload')
      const response = await request.post(endpoint, {
        fileName,
        contentType
      })

      console.log('Signed URL response:', response)
      // response.data contains the actual data (uploadUrl, publicUrl)
      const data = response.data as SignedUploadResponse

      const uploadResponse = await fetch(data.uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': contentType
        },
        body
      })

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text()
        console.error('Upload failed:', errorText)
        throw new Error(`Upload failed with status ${uploadResponse.status}: ${errorText}`)
      }

      return { Location: data.publicUrl }
    } catch (error: any) {
      console.error('uploadViaSignedUrl error:', error)
      console.error('Error response:', error.response?.data)
      throw error
    }
  }

  private base64ToBlob(base64: string, contentType: string) {
    const binary = window.atob(base64)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i)
    }
    return new Blob([bytes], { type: contentType })
  }

  uploadImage(payload: { file: string, fileName: string, contentType: string }): Promise<any> {
    const blob = this.base64ToBlob(payload.file, payload.contentType)
    return this.uploadViaSignedUrl(blob, payload.fileName, payload.contentType)
  }

  uploadFile(payload: { file: File, fileName: string, contentType: string }): Promise<any> {
    return this.uploadViaSignedUrl(payload.file, payload.fileName, payload.contentType)
  }
}

export default Uploader
